import './SearchInput.sass';
import React, { FC, useCallback, useMemo } from 'react';
import { SearchInputProps } from '$uikit/SearchInput/SearchInput.interface';
import { Input } from '$uikit/index';
import { IcClose16 } from '$assets';
import { useDesktop } from '$hooks';

export const SearchInput: FC<SearchInputProps> = (props) => {
  const isDesktop = useDesktop();

  const { query, onChange, rightButtons = null, placeholder, placeholderIcon } = props;

  const queryPrepared = useMemo(() => {
    return query.trim();
  }, [query]);

  const handleChange = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  const handleClear = useCallback(() => {
    onChange('');
  }, [onChange]);

  return (
    <div className="SearchInput">
      <div className="SearchInput__input">
        <Input
          disabled={props.disabled}
          autoFocus={isDesktop}
          placeholder={placeholder}
          onChange={handleChange}
          value={query}
        />
        {!!placeholderIcon && queryPrepared.length === 0 && (
          <div className="SearchInput__icon">{placeholderIcon}</div>
        )}
        {queryPrepared.length > 0 && (
          <div className="SearchInput__button SearchInput__icon" onClick={handleClear}>
            <IcClose16 />
          </div>
        )}
      </div>
      {rightButtons && <div className="SearchInput__buttons">{rightButtons}</div>}
    </div>
  );
};
